/**
 * Constants to be used through out the library
 * @namespace constants
 */

/**
 * @typedef {Object} FormatterType
 * @readonly
 * @property {String} SCHEMA_NAME_ARGUMENT schema-name-argument
 * */

/**
 * Constant file to reference the formatters
 * @readonly
 * @enum {FormatterType}
 * @memberof constants
 */
const FormatterTypes = {
  SCHEMA_NAME_ARGUMENT: 'schema-name-argument',
};

/**
 * @typedef {Object} ValidatorType
 * @readonly
 * @property {String} DOB dob
 * @property {String} DOB_REQUIRED dobRequired
 * @property {String} IS_ADULT isAdult
 * @property {String} EMAIL email
 * @property {String} EMAIL_REQUIRED emailRequired
 * @property {String} NAME name
 * @property {String} NAME_REQUIRED nameRequired
 * @property {String} ALPHANUMERIC_NAME alphanumericName
 * @property {String} ALPHANUMERIC_NAME_REQUIRED alphanumericNameRequired
 * @property {String} PHONE_NUMBER phoneNumber,
 * @property {String} SALES_VX_SPLIT sales-vx-split
 * @property {String} SALES_VX_PURPOSE sales-vx-purpose
 * @property {String} SALES_VX_DEPOSIT sales-vx-deposit
 * @property {String} SALES_VX_RECEIPT sales-vx-receipt
 * @property {String} SALES_VX_DISBURSEMENT_PURPOSE sales-vx-disbursement-purpose
 * @property {String} SALES_VX_ATTACH_MEMBER sales-vx-attach-member-to-application
 * @property {String} SALES_VX_ACCOUNTING_FEE sales-vx-accounting-fee
 * @property {String} SALES_VX_SECURITY sales-vx-security
 * */

/**
 * Constant file to reference the validators
 * @readonly
 * @enum {ValidatorType}
 * @memberof constants
 */
const ValidatorTypes = {
  DOB: 'dob',
  DOB_REQUIRED: 'dobRequired',
  IS_ADULT: 'isAdult',
  EMAIL: 'email',
  EMAIL_REQUIRED: 'emailRequired',
  NAME: 'name',
  NAME_REQUIRED: 'nameRequired',
  ALPHANUMERIC_NAME: 'alphanumericName',
  ALPHANUMERIC_NAME_REQUIRED: 'alphanumericNameRequired',
  PHONE_NUMBER: 'phoneNumber',
  SALES_VX_SPLIT: 'sales-vx-split',
  SALES_VX_PURPOSE: 'sales-vx-purpose',
  SALES_VX_DEPOSIT: 'sales-vx-deposit',
  SALES_VX_RECEIPT: 'sales-vx-receipt',
  SALES_VX_DISBURSEMENT_PURPOSE: 'sales-vx-disbursement-purpose',
  SALES_VX_ATTACH_MEMBER: 'sales-vx-attach-member-to-application',
  SALES_VX_ACCOUNTING_FEE: 'sales-vx-accounting-fee',
  SALES_VX_SECURITY: 'sales-vx-security',
  SALES_CLIENT_ADDRESS: 'sales-client-address',
  SALES_VX_COLLATERAL_MOTOR_VEHICLE: 'sales-vx-collateral-motor-vehicle',
  SALES_VX_COLLATERAL_INVOICE: 'sales-vx-collateral-invoice',
  SALES_VX_REPAYMENT_CALCULATOR: 'sales-vx-repayment-calculator',
  SALES_VX_FEE_CONFIG_LOOKUP: 'sales-vx-core-fee-configuration-lookup',
  CLIENT_BRANDSTORE: 'client-brandstore',
  ACCOUNT_TRANSACTION: 'account-transaction',
  PRODUCT_LOAN_AMOUNT: 'product-loan-amount',
  FEE_CONFIGURATION: 'fee-configuration',
  SALES_VX_ACCOUNTING_FEE_CONFIG: 'sales-vx-accounting-fee-configuration',
  PAYMENT_REQUEST: 'payment-request',
  PAYMENT_SUBMISSION: 'payment-submission',
  EMPLOYMENT: 'employment',
};

module.exports = {
  FormatterTypes,
  ValidatorTypes,
};
